import {
  SkeletonWrapper,
  SkeletonText,
  SkeletonAvatar,
  SpacingToken,
} from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import Divider from '@/components/Checkout/Wrapper/Divider'
import mediaQueries from '@/layout/media-queries'

export const itemWrapperCss = css`
  display: flex;
  flex-flow: column nowrap;
  gap: var(${SpacingToken.Spacing2});

  > div:last-of-type {
    display: none;
  }

  ${mediaQueries.xsmallScreen()} {
    flex-flow: row nowrap;
    justify-content: space-between;

    > div:last-of-type {
      display: flex;
      align-items: flex-end;
    }
  }
`

export const paymentWrapperCss = css`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  gap: var(${SpacingToken.Spacing2});

  ${mediaQueries.xsmallScreen()} {
    flex-flow: row;
  }
`

export const ContentLoader = () => (
  <div>
    <div css={itemWrapperCss}>
      <SkeletonWrapper>
        <SkeletonAvatar size={48} square />
        <SkeletonWrapper vertical>
          <SkeletonText width={100} height={20} />
          <SkeletonText width={220} height={14} />
        </SkeletonWrapper>
      </SkeletonWrapper>

      <SkeletonWrapper vertical>
        <SkeletonText width={60} height={20} />
        <SkeletonText width={40} height={14} />
      </SkeletonWrapper>
    </div>

    <Divider />

    <div css={paymentWrapperCss}>
      <SkeletonWrapper vertical>
        <SkeletonText width={100} height={20} />
        <SkeletonText width={220} height={14} />
      </SkeletonWrapper>

      <SkeletonText width={60} height={20} />
    </div>
  </div>
)

export default ContentLoader
